import { render, staticRenderFns } from "./detail_p.vue?vue&type=template&id=2afe3c88&scoped=true"
import script from "./detail_p.vue?vue&type=script&lang=js"
export * from "./detail_p.vue?vue&type=script&lang=js"
import style0 from "./detail_p.vue?vue&type=style&index=0&id=2afe3c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe3c88",
  null
  
)

export default component.exports